/* unplugin-vue-components disabled */import script from "./pdf-download-dropdown.vue?vue&type=script&lang=js"
export * from "./pdf-download-dropdown.vue?vue&type=script&lang=js"

import "./pdf-download-dropdown.vue?vue&type=style&index=0&id=6340bd52&lang=scss"

const __exports__ = script;

export default __exports__